import React from "react";
import { useDeleteScheduledPostMutation } from "../../post.service";
import { ScheduledPost } from "../../types/scheduled-posts.entity";
import Modal from "src/components/modal/modal";

type Props = {
  post: ScheduledPost;
  onClose: () => void;
};

export const DeleteScheduledPost: React.FC<Props> = ({ post, onClose }) => {
  const [deletePost, { isLoading, isError, error }] = useDeleteScheduledPostMutation();

  const confirmDelete = async () => {
    try {
      await deletePost(post.id).unwrap();
      onClose();
    } catch (err) {
      console.error("Failed to delete scheduled post:", err);
    }
  };

  return (
    <Modal onClose={onClose} isOpen={true} hideFooter={true}>
      <div className="p-4">
        <h2 className="text-lg font-semibold mb-2">Delete Scheduled Post</h2>

        <p className="text-sm text-gray-600 mb-4">
          Are you sure you want to delete the scheduled post titled:
          <span className="font-medium"> "{post.content.slice(0, 40)}..."</span>?
          <br />
          This action cannot be undone.
        </p>

        {isError && (
          <p className="text-red-500 text-sm mb-3">{(error as any)?.data?.message || "Failed to delete the post."}</p>
        )}

        <div className="flex justify-end gap-3 mt-4">
          <button onClick={onClose} disabled={isLoading} className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300">
            Cancel
          </button>

          <button
            onClick={confirmDelete}
            disabled={isLoading}
            className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-70"
          >
            {isLoading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </Modal>
  );
};
